import { useEffect } from "react";

const BASE_TITLE = "Louve Hinos Avulsos Oficial – Letras e Cifras Atualizadas";
const BASE_URL = "https://louvehinosavulsos.com.br";

export const usePageTitle = (title?: string, meta?: { 
  description?: string; 
  ogImage?: string; 
  ogUrl?: string;
  canonical?: string;
  keywords?: string;
}) => {
  useEffect(() => {
    document.title = title ? `${title} | ${BASE_TITLE}` : BASE_TITLE;

    // Canonical URL
    const canonicalUrl = meta?.canonical || (typeof window !== 'undefined' ? `${BASE_URL}${window.location.pathname}` : BASE_URL);
    let canonicalTag = document.querySelector('link[rel="canonical"]') as HTMLLinkElement;
    if (!canonicalTag) {
      canonicalTag = document.createElement("link");
      canonicalTag.rel = "canonical";
      document.head.appendChild(canonicalTag);
    }
    canonicalTag.href = canonicalUrl;

    // Meta description
    if (meta?.description) {
      setMeta('name', 'description', meta.description);
      setMeta('property', 'og:description', meta.description);
      setMeta('name', 'twitter:description', meta.description);
    }

    // OG title
    if (title) {
      setMeta('property', 'og:title', title);
      setMeta('name', 'twitter:title', title);
    }

    // OG image
    if (meta?.ogImage) {
      setMeta('property', 'og:image', meta.ogImage);
      setMeta('name', 'twitter:image', meta.ogImage);
    }

    // OG URL
    setMeta('property', 'og:url', meta?.ogUrl || canonicalUrl);

    // Keywords
    if (meta?.keywords) {
      setMeta('name', 'keywords', meta.keywords);
    }

    return () => {
      document.title = BASE_TITLE;
    };
  }, [title, meta?.description, meta?.ogImage, meta?.ogUrl, meta?.canonical, meta?.keywords]);
};

function setMeta(attr: 'name' | 'property', key: string, content: string) {
  let tag = document.querySelector(`meta[${attr}="${key}"]`) as HTMLMetaElement;
  if (!tag) {
    tag = document.createElement("meta");
    tag.setAttribute(attr, key);
    document.head.appendChild(tag);
  }
  tag.content = content;
}
